import { html, optionalAttribute } from '@webtides/element-js';

export function responsiveImage(
    image,
    cssClass = '',
    lazyload = true,
    fetchPriority = 'auto',
    sizes = '',
    loading = 'lazy',
) {
    if (!image?.srcset) return '';
    if (lazyload)
        // TODO: bug in element-js -> cannot render this attribute: src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        return html`
            <img
                data-src="${image?.src}"
                data-srcset="${image?.srcset}"
                ${optionalAttribute(sizes, 'data-sizes', sizes)}
                class="lazyload ${cssClass}"
                alt="${image?.alt ?? ''}"
            />
        `;
    return html`
        <img
            src="${image?.src}"
            srcset="${image?.srcset}"
            ${optionalAttribute(sizes, 'sizes', sizes)}
            class="lazyload ${cssClass}"
            alt="${image?.alt ?? ''}"
            fetchpriority="${fetchPriority}"
            loading="${loading}"
        />
    `;
}
